import { Box, Grid, Paper, Typography } from "@mui/material"
import { ReportTabs } from "components/Common/ReportTabs"
import { Title } from "components/Common/Title"
import { useEffect, useState } from "react"
import organizationService from "services/organizationService"
import type { IAllOrganizationsReport } from "types/reportTypes"

const statSx = { fontSize: "clamp(1.5rem, 3vw, 3.5rem)" }
const cardSx = { p: 2, display: "flex", flexDirection: "column", minHeight: 130 }
const cardInnerSx = { display: "flex", flexDirection: "column", flexGrow: 1 }
const cardValueSx = { display: "flex", flexGrow: 1, justifyContent: "center", alignItems: "center" }

export function UsageReport() {
  const [report, setReport] = useState<IAllOrganizationsReport | undefined>(undefined)

  useEffect(() => {
    organizationService
      .getAllOrganizationsReport()
      .then((data) => {
        setReport(data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ReportTabs activeTab={0} />
      </Grid>

      <Grid item container spacing={3}>
        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>ORGANIZATIONS</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report?.organizations ?? "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>USERS</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report?.users ?? "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>ASSIGNED LICENSES</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report !== undefined ? `${report.assignedLicenses} / ${report.licenses}` : "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>LESSONS DONE</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report?.lessonsDone ?? "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Grid item container spacing={3}>
        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>EXAMS DONE</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report?.examsDone ?? "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>EXAMS PASSED</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report !== undefined ? `${report.examsPassedPercentage}%` : "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={3}>
          <Paper sx={cardSx}>
            <Box sx={cardInnerSx}>
              <Title>TOTAL TRAINING HOURS</Title>
              <Box sx={cardValueSx}>
                <Typography variant="h1" sx={statSx}>
                  {report !== undefined ? `${report.totalTrainingHours}h` : "—"}
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  )
}
